import React from 'react'
import CV from '../../assets/Resume_TranDoanCuong.pdf'

const CTA = () => {
    return (
        <div>
            <div className='cta'>
                <a href={CV} download className='btn'>Download CV</a>
                <a href="#contact" className='btn btn-primary'>Let's Talk</a>
            </div>
        </div>
    )
}

export default CTA